import React, { createContext, useContext, useState, useCallback } from 'react';
import { tasksAPI } from '../utils/api';

const TaskContext = createContext();

export const useTask = () => {
  const context = useContext(TaskContext);
  if (!context) throw new Error('useTask must be used within TaskProvider');
  return context;
};

export const TaskProvider = ({ children }) => {
  const [tasks, setTasks] = useState([]);
  const [stats, setStats] = useState({ todo: 0, 'in-progress': 0, done: 0 });
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    status: 'all',
    priority: 'all',
    category: 'all',
    search: '',
    sortBy: 'createdAt',
    order: 'desc'
  });

  const fetchTasks = useCallback(async (customFilters) => {
    setLoading(true);
    try {
      const params = customFilters || filters;
      const cleanParams = Object.fromEntries(
        Object.entries(params).filter(([, v]) => v && v !== 'all')
      );
      const res = await tasksAPI.getAll(cleanParams);
      setTasks(res.data.tasks);
      setStats(res.data.stats);
    } catch (err) {
      console.error('Erreur chargement tâches:', err);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  const createTask = async (taskData) => {
    const res = await tasksAPI.create(taskData);
    await fetchTasks();
    return res.data.task;
  };

  const updateTask = async (id, taskData) => {
    const res = await tasksAPI.update(id, taskData);
    setTasks(prev => prev.map(t => t._id === id ? res.data.task : t));
    await fetchTasks();
    return res.data.task;
  };

  const deleteTask = async (id) => {
    await tasksAPI.delete(id);
    setTasks(prev => prev.filter(t => t._id !== id));
    await fetchTasks();
  };

  const updateFilters = (newFilters) => {
    const updated = { ...filters, ...newFilters };
    setFilters(updated);
    fetchTasks(updated);
  };

  return (
    <TaskContext.Provider value={{
      tasks, stats, loading, filters,
      fetchTasks, createTask, updateTask, deleteTask, updateFilters
    }}>
      {children}
    </TaskContext.Provider>
  );
};
